// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Htia","name":"ConsentHeader_name__ictzU","birthday":"ConsentHeader_birthday__3zv19","skeleton":"ConsentHeader_skeleton__2q_UN"};